"use strict";
/**
 *  Module  部门稿库模板
 *  createBy  zhang.yingyu
 * Description  2018-11-23
 */
angular.module('iwoDepartRejectionModule', []).controller('iwoDepartRejectionCtrl', ['$scope', '$q', '$modalInstance', '$timeout', '$filter', 'initSingleSelecet', 'trsHttpService', "modalDialog", "params",'trsspliceString',
    function($scope, $q, $modalInstance, $timeout, $filter, initSingleSelecet, trsHttpService, modalDialog, params,trsspliceString) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data={
                items:params.items
            };
            $scope.rejectParams={
                serviceid:"mlf_departoperdoc",
                methodname:"rejectedDepartDocs",
                DepartdocrelIds:'',
                opinion:'',
            };
        }
        /**
         * [initData description] 初始数据
         * @return {[type]} [description]
         */
        function initData(){};
        /**
         * [handleTitle description] 处理标题
         * @param {object} [item] [description] 列表数据
         * @return {[type]} [description]
         */
        $scope.handleTitle = function(item) {
            item.TITLE = $("<div>" + item.TITLE + "</div>").text();
        };
        /**
         * [singleDel description] 删除已选稿件
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleDel = function(item) {
            modalDialog.alertType('是否删除稿件', "", "ask", true, function () {
                modalDialog.alertType('删除成功', '', 'success', false, function() {
                    $scope.data.items.splice($scope.data.items.indexOf(item), 1);
                    if($scope.data.items.length==0){
                        $modalInstance.close("error");
                    }else{
                        return;
                    }
                });
            });
        };
        /**
         * [confirm description] 取消
         * @return {[type]} [description]
         */
        $scope.confirm = function () {
            $scope.rejectParams.opinion=$scope.data.opinion;
            $scope.rejectParams.DepartdocrelIds=trsspliceString.spliceString($scope.data.items, 'DEPARTDOCRELID', ',');
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.rejectParams, "post").then(function(data) {
                if(data.ISSUCCESS=='true'){
                    modalDialog.alertType("退稿成功", "", "success", false, function () {
                        $modalInstance.close('success');
                    });
                }
            });
        };
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function () {
            $modalInstance.close();
        };

}]);